import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    name, code
  } = dataSource;

  return {
    name: Form.createFormField({ value: name }),
    code: Form.createFormField({ value: code })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, inputFormItemLayout, form
}) => {
  const { getFieldDecorator } = form;
  const {
    name, code
  } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the Activity Type name.'
            }]
          })(<Input disabled={readonly} />)
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Code" help="Maximum of 5 characters">
        {
          getFieldDecorator('code', {
            initialValue: code,
            rules: [{
              required: true,
              message: 'Please enter the Activity Type code.'
            },
            {
              max: 5,
              message: 'Maximum of 5 characters allowed.'
            }]
          })(<Input disabled={readonly} />)
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const ActivityTypeInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default ActivityTypeInput;
